export enum ShortFormElementType {
  Text = "Text",
  Address = "Address",
}
